module.exports = __webpack_public_path__ + "static/media/dual-screen-small@2x.b047affd.png";